module.exports = __webpack_public_path__ + "img/蜂蜜3.17a9030a.png";